import { IRecipient } from "../../../store/slices/c2cSlice"

type IContactsByAlphabet = {
  [key: string]: IRecipient[]
}

export const useContactsByAlphabet = (contacts: IRecipient[]) => {
  const contactsByAlphabet: IContactsByAlphabet = {}

  contacts.forEach((contact) => {
    const firstLetter = contact.name!.charAt(0).toUpperCase()
    if (!contactsByAlphabet[firstLetter]) {
      contactsByAlphabet[firstLetter] = []
    }
    contactsByAlphabet[firstLetter].push(contact)
  })

  const sortedAlphabet = Object.keys(contactsByAlphabet).sort()

  return { contactsByAlphabet, sortedAlphabet }
}
